import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsSmartWatch: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.14 22.86v-7.62h1.53v-3.05h-1.53V9.14h-1.52v13.72zm-3.05 0h1.53v1.52h-1.53Zm0-15.24h1.53v1.52h-1.53Zm-1.52 4.57h1.52v7.62h-1.52ZM19.05 32v-1.52h1.52v-1.53h1.52v-1.52H8.38v1.52H9.9v1.53h1.53V32zM8.38 24.38h13.71v1.52H8.38Zm10.67-4.57h1.52v1.52h-1.52Zm0-9.14h1.52v1.52h-1.52Zm-1.53 3.04h1.53v4.58h-1.53Zm-3.04-4.57h4.57v1.53h-4.57Zm-3.05 12.19h7.62v1.53h-7.62Zm3.05-9.14h3.04v1.52h-3.04Zm-1.53 6.1h4.57v1.52h-4.57Zm1.53-3.05H16v1.52h-1.52ZM9.9 19.81h1.53v1.52H9.9ZM8.38 6.1h13.71v1.52H8.38ZM11.43 0v1.52H9.9v1.53H8.38v1.52h13.71V3.05h-1.52V1.52h-1.52V0zM6.86 22.86h1.52v1.52H6.86Zm0-15.24h1.52v1.52H6.86ZM5.33 9.14h1.53v13.72H5.33Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsSmartWatch
